import { connect, ConnectedProps } from 'react-redux'

import GroupListItem from 'components/accordion/GroupListItem'
import {
  setAccordionBreadCrumbClicked,
  setAccordionExpandedNodeId,
  setAccordionExpandedNodeTitle
} from 'redux/actions'
import { AppDispatch, RootState } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  expandedNodeTitle: state.accordion.expandedNodeTitle
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setAccordionExpandedNodeId: (expandedNodeId: string) => dispatch(setAccordionExpandedNodeId(expandedNodeId)),
  setAccordionExpandedNodeTitle: (expandedNodeTitle: string) => dispatch(setAccordionExpandedNodeTitle(expandedNodeTitle)),
  setAccordionBreadCrumbClicked: (breadCrumbClicked: boolean) => dispatch(setAccordionBreadCrumbClicked(breadCrumbClicked))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type GroupListItemContainerProps = ConnectedProps<typeof connector>

export default connector(GroupListItem)
